// One label/value row inside the Personal information card. A nil value renders
// a muted "Not set". Read-only rows (username, email) get a subtle tag so it's
// clear those edits live in Settings, not the Profile modal (D4).
//
// P8-H7 "Muster" — the value WRAPS in the starved 861–1023 band. Dropping the
// page grid to 861 leaves this card in a ~337px column while the 224px shell rail
// is still on screen, and `truncate` then ate the customer's own data: the email
// clipped at 146px of the 177 it needs, the address at 216 of 309. There is no
// `title` attribute here, so a truncated value is simply unreachable — the
// customer cannot read their own address. The prototype never truncated: profile
// .html's `.info-row .iv{flex:1;min-width:0}` has no ellipsis, so the value is
// meant to run onto a second line. `whitespace-normal` + `text-clip` +
// `overflow-visible` undo `truncate`'s three declarations exactly, and
// `wrap-break-word` lets a single long token (an email, a URL) break rather than
// spill out of the card. Strictly band-scoped: at 1280 the values fit on one line
// and that rendering is byte-identical to before.
export default function InfoRow({ label, value, readOnly = false }) {
  const empty = value == null || value === ""

  return (
    <div className="flex items-start justify-between gap-6 border-b border-border px-[22px] py-[13px] last:border-b-0">
      <span className="shrink-0 text-[13px] font-medium text-ink-3">{label}</span>
      <span className="flex min-w-0 items-center gap-2 text-right">
        <span
          data-testid="info-value"
          className={
            empty
              ? "text-[13.5px] text-muted-foreground"
              : "truncate text-[13.5px] font-medium text-foreground min-[861px]:max-[1024px]:overflow-visible min-[861px]:max-[1024px]:text-clip min-[861px]:max-[1024px]:whitespace-normal min-[861px]:max-[1024px]:wrap-break-word"
          }
        >
          {empty ? "Not set" : value}
        </span>
        {readOnly && (
          <span className="shrink-0 rounded bg-secondary px-1.5 py-0.5 text-[10px] font-semibold tracking-wide text-ink-3 uppercase">
            Read only
          </span>
        )}
      </span>
    </div>
  )
}
